import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '../context/AuthContext'
import { Spinner } from './ui/Spinner'

export function AppGate({ children }: { children: ReactNode }) {
  const { loading, authConfig } = useAuth()
  const location = useLocation()

  if (loading || !authConfig) return <Spinner fullscreen />

  if (!authConfig.setupCompleted && location.pathname !== '/setup') {
    return <Navigate to="/setup" replace />
  }
  if (authConfig.setupCompleted && location.pathname === '/setup') {
    return <Navigate to="/" replace />
  }
  return <>{children}</>
}

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()
  if (loading) return <Spinner fullscreen />
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />
  return <>{children}</>
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()
  if (loading) return <Spinner fullscreen />
  if (!user) return <Navigate to="/login" replace />
  if (user.role !== 'ADMIN') return <Navigate to="/" replace />
  return <>{children}</>
}
